/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
 
  this.atc_button = document.querySelector('[data-fixed-atc]');
  if (atc_button) {
    this.screenHeight = document.documentElement.clientHeight;
    window.addEventListener('scroll', this.updateFixed.bind(this));
    this.updateFixed();
    
    try {
      customElements.define('fixed-atc', FixedATC);
    }
    catch(e) {
      console.log("fixed-atc already defined", e)
    }
  }

  // Mobile Quickview Add to Cart Button Management
  let mobileQuickviewButton = null;

  function createMobileQuickviewButton() {
    if (window.innerWidth <= 767 && !mobileQuickviewButton) {
      // Create mobile button once and keep it in DOM
      mobileQuickviewButton = document.createElement('button');
      mobileQuickviewButton.id = 'quickview-mobile-atc';
      mobileQuickviewButton.innerHTML = 'Loading...';
      document.body.appendChild(mobileQuickviewButton);
      console.log('Mobile quickview button created!');
    }
  }

  function updateMobileQuickviewButton() {
    if (!mobileQuickviewButton || window.innerWidth > 767) return;
    
    const quickviewModal = document.querySelector('.quickview__modal.is-open');
    if (quickviewModal) {
      // Get the original form
      const originalForm = quickviewModal.querySelector('form[data-product-form]');
      if (!originalForm) return;
      
      // Get product data
      const addToCartText = originalForm.querySelector('[data-add-to-cart-text]')?.textContent || 'Add to Cart';
      const buttonPrice = originalForm.querySelector('[data-button-price]')?.textContent || '';
      
      // Update button content
      mobileQuickviewButton.innerHTML = `${addToCartText} ${buttonPrice ? '• ' + buttonPrice : ''}`;
      
      // Update click handler (remove old ones first)
      mobileQuickviewButton.replaceWith(mobileQuickviewButton.cloneNode(true));
      mobileQuickviewButton = document.getElementById('quickview-mobile-atc');
      
      mobileQuickviewButton.addEventListener('click', function() {
        const currentForm = document.querySelector('.quickview__modal.is-open form[data-product-form]');
        const originalButton = currentForm?.querySelector('button[name="add"]');
        if (originalButton) {
          originalButton.click();
        } else if (currentForm) {
          currentForm.submit();
        }
      });
      
      // Add body class to show button
      document.body.classList.add('quickview-open');
      console.log('Mobile quickview button updated and shown!');
    }
  }

  function hideMobileQuickviewButton() {
    document.body.classList.remove('quickview-open');
    console.log('Mobile quickview button hidden!');
  }

  // Create button on page load
  createMobileQuickviewButton();

  // Listen for quickview open
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-quickview]')) {
      setTimeout(updateMobileQuickviewButton, 500);
    }
  });

  // Listen for modal close - multiple ways to detect close
  document.addEventListener('click', function(e) {
    // Close button clicked
    if (e.target.matches('[data-micromodal-close]') || e.target.closest('[data-micromodal-close]')) {
      hideMobileQuickviewButton();
    }
    // Clicked outside modal (underlay)
    if (e.target.matches('.drawer__underlay') || e.target.closest('.drawer__underlay')) {
      hideMobileQuickviewButton();
    }
  });

  // Also listen for ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.querySelector('.quickview__modal.is-open')) {
      hideMobileQuickviewButton();
    }
  });

  // Use MutationObserver to detect when quickview modal closes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('quickview__modal')) {
          if (!target.classList.contains('is-open')) {
            hideMobileQuickviewButton();
          }
        }
      }
    });
  });

  // Start observing for changes
  const quickviewModal = document.querySelector('.quickview__modal');
  if (quickviewModal) {
    observer.observe(quickviewModal, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Listen for variant changes
  document.addEventListener('theme:variant:change', function(event) {
    if (event.target.closest('.quickview__modal')) {
      setTimeout(updateMobileQuickviewButton, 100);
    }
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 767) {
      createMobileQuickviewButton();
    }
  });

  // Mobile sticky CTA for CPB "Débuter la personnalisation":
  // pushes Smile + Chat launchers up so they don't visually collide with the always-visible CTA.
  // The CTA itself stays sticky via CSS (position: fixed) — no scroll-hide logic.
  (function setupPersonalizeStickyCTA() {
    if (window.innerWidth > 767) return;

    function apply() {
      const cta = document.querySelector('.personalize-it--js');
      if (!cta) return false;

      const smile = document.querySelector('.smile-launcher-frame-container');
      const chat = document.querySelector('#chat-button');
      if (smile) smile.classList.add('cta-personalize');
      if (chat) chat.classList.add('cta-personalize');

      // Done once everything is present
      return Boolean(smile && chat);
    }

    if (!apply()) {
      const observer = new MutationObserver(() => {
        if (apply()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Safety cutoff so we don't observe forever if a widget never loads
      setTimeout(() => observer.disconnect(), 30000);
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

function disconnectedCallback() {
  window.removeEventListener('scroll', this.updateFixed)
};

function updateFixed() {
  const screenBottom = window.pageYOffset + this.screenHeight;
  let footerOffsetTop = document.querySelector('.shopify-section-group-group-footer').getBoundingClientRect().top + window.scrollY;
  atc_button.classList.toggle('open', screenBottom <= footerOffsetTop);

  this.smile_button = document.querySelector('.smile-launcher-frame-container');
  this.chat_button = document.querySelector('#chat-button');

  if (smile_button) {
    smile_button.classList.toggle('open', screenBottom <= footerOffsetTop);
  }

  if (chat_button) {
    chat_button.classList.toggle('open', screenBottom <= footerOffsetTop);
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    if (smile_button) {
      smile_button.classList.toggle('variant-sold-out', !variant.available);
    }
    if (chat_button) {
      chat_button.classList.toggle('variant-sold-out', !variant.available);
    }
  });
};
